module.exports = "<div class=\"ui-g-12 explorer-panel\">\n   \n    <div class=\"ui-g-3 category-explorer-container\">\n        <category-explorer></category-explorer>\n    </div>\n    <div class=\"ui-g-9 document-explorer-container\" >\n        <document-explorer></document-explorer>\n        <div class=\"loading-screen\" [class.active]=\"loading\">\n            <mat-spinner [diameter]=\"50\"></mat-spinner>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/fiscalia/component/repository/explorer/explorer.component.html
// module id = ./src/app/fiscalia/component/repository/explorer/explorer.component.html
// module chunks = main